/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: iS5v7Dj2DD0h

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import News from "../../News"; // plasmic-import: R99muOTbbJZX/component
import ForgotPasswordForm from "../../ForgotPasswordForm"; // plasmic-import: OEpgQT6ESYK5/component
import LoginTroubleshootingModal from "../../LoginTroubleshootingModal"; // plasmic-import: jOhB8EyLNa7v/component
import ContactModal from "../../ContactModal"; // plasmic-import: 2lCEPY1ezZ3j/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicForgotPassword.module.css"; // plasmic-import: iS5v7Dj2DD0h/css

const emptyProxy: any = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q: any): any {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export type PageCtx = {
  pageRoute: string;
  pagePath: string;
  params: Record<string, string | string[] | undefined>;
  query: Record<string, string | string[] | undefined>;
};

export function generateDynamicMetadata($q: any, $ctx: PageCtx) {
  return {
    title: "Reset Your MyEvaluations Password | Secure Account Management",
    description:
      "Easily reset your password to continue managing your medical education programs.",
    openGraph: {
      title: "Reset Your MyEvaluations Password | Secure Account Management",
      description:
        "Easily reset your password to continue managing your medical education programs."
    },
    twitter: {
      card: "summary" as const,
      title: "Reset Your MyEvaluations Password | Secure Account Management",
      description:
        "Easily reset your password to continue managing your medical education programs."
    }
  };
}

createPlasmicElementProxy;

export type PlasmicForgotPassword__VariantMembers = {};
export type PlasmicForgotPassword__VariantsArgs = {};
type VariantPropType = keyof PlasmicForgotPassword__VariantsArgs;
export const PlasmicForgotPassword__VariantProps = new Array<VariantPropType>();

export type PlasmicForgotPassword__ArgsType = {};
type ArgPropType = keyof PlasmicForgotPassword__ArgsType;
export const PlasmicForgotPassword__ArgProps = new Array<ArgPropType>();

export type PlasmicForgotPassword__OverridesType = {
  root?: Flex__<"div">;
  desktop?: Flex__<"div">;
  content?: Flex__<"div">;
  mobile?: Flex__<"div">;
  loginTroubleshootingModal?: Flex__<typeof LoginTroubleshootingModal>;
  contactModal?: Flex__<typeof ContactModal>;
};

export interface DefaultForgotPasswordProps {}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicForgotPassword__RenderFunc(props: {
  variants: PlasmicForgotPassword__VariantsArgs;
  args: PlasmicForgotPassword__ArgsType;
  overrides: PlasmicForgotPassword__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "loginTroubleshootingModal.open",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "contactModal.open",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const pageMetadata = generateDynamicMetadata(
    wrapQueriesWithLoadingProxy({}),
    $ctx as PageCtx
  );

  const styleTokensClassNames = _useStyleTokens();

  return (
    <React.Fragment>
      <Head>
        <meta name="twitter:card" content="summary" />
        <title key="title">{pageMetadata.title}</title>
        <meta key="og:title" property="og:title" content={pageMetadata.title} />
        <meta
          key="twitter:title"
          property="twitter:title"
          content={pageMetadata.title}
        />
        <meta
          key="description"
          property="description"
          content={pageMetadata.description}
        />
        <meta
          key="og:description"
          property="og:description"
          content={pageMetadata.description}
        />
        <meta
          key="twitter:description"
          property="twitter:description"
          content={pageMetadata.description}
        />
      </Head>

      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            styleTokensClassNames,
            sty.root
          )}
        >
          {(
            hasVariant(globalVariants, "mobile", "mobile")
              ? false
              : hasVariant(globalVariants, "mobile", "tabletPortrait")
                ? false
                : true
          ) ? (
            <div
              data-plasmic-name={"desktop"}
              data-plasmic-override={overrides.desktop}
              className={classNames(projectcss.all, sty.desktop)}
            >
              <div
                data-plasmic-name={"content"}
                data-plasmic-override={overrides.content}
                className={classNames(projectcss.all, sty.content)}
              >
                <News
                  className={classNames("__wab_instance", sty.news__vwqO)}
                />

                <ForgotPasswordForm
                  className={classNames(
                    "__wab_instance",
                    sty.forgotPasswordForm__hVwb
                  )}
                  onHelpClick={async () => {
                    const $steps = {};

                    $steps["updateLoginTroubleshootingModalOpen"] = true
                      ? (() => {
                          const actionArgs = {
                            variable: {
                              objRoot: $state,
                              variablePath: [
                                "loginTroubleshootingModal",
                                "open"
                              ]
                            },
                            operation: 0,
                            value: true
                          };
                          return (({
                            variable,
                            value,
                            startIndex,
                            deleteCount
                          }) => {
                            if (!variable) {
                              return;
                            }
                            const { objRoot, variablePath } = variable;

                            $stateSet(objRoot, variablePath, value);
                            return value;
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["updateLoginTroubleshootingModalOpen"] != null &&
                      typeof $steps["updateLoginTroubleshootingModalOpen"] ===
                        "object" &&
                      typeof $steps["updateLoginTroubleshootingModalOpen"]
                        .then === "function"
                    ) {
                      $steps["updateLoginTroubleshootingModalOpen"] =
                        await $steps["updateLoginTroubleshootingModalOpen"];
                    }
                  }}
                />
              </div>
            </div>
          ) : null}
          {(
            hasVariant(globalVariants, "mobile", "mobile")
              ? true
              : hasVariant(globalVariants, "mobile", "tabletPortrait")
                ? true
                : false
          ) ? (
            <div
              data-plasmic-name={"mobile"}
              data-plasmic-override={overrides.mobile}
              className={classNames(projectcss.all, sty.mobile)}
            >
              <ForgotPasswordForm
                className={classNames(
                  "__wab_instance",
                  sty.forgotPasswordForm__t4KkE
                )}
                onHelpClick={async () => {
                  const $steps = {};

                  $steps["updateLoginTroubleshootingModalOpen"] = true
                    ? (() => {
                        const actionArgs = {
                          variable: {
                            objRoot: $state,
                            variablePath: ["loginTroubleshootingModal", "open"]
                          },
                          operation: 0,
                          value: true
                        };
                        return (({
                          variable,
                          value,
                          startIndex,
                          deleteCount
                        }) => {
                          if (!variable) {
                            return;
                          }
                          const { objRoot, variablePath } = variable;

                          $stateSet(objRoot, variablePath, value);
                          return value;
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["updateLoginTroubleshootingModalOpen"] != null &&
                    typeof $steps["updateLoginTroubleshootingModalOpen"] ===
                      "object" &&
                    typeof $steps["updateLoginTroubleshootingModalOpen"]
                      .then === "function"
                  ) {
                    $steps["updateLoginTroubleshootingModalOpen"] =
                      await $steps["updateLoginTroubleshootingModalOpen"];
                  }
                }}
              />

              <News
                className={classNames("__wab_instance", sty.news___2C30P)}
              />
            </div>
          ) : null}
          <LoginTroubleshootingModal
            data-plasmic-name={"loginTroubleshootingModal"}
            data-plasmic-override={overrides.loginTroubleshootingModal}
            className={classNames(
              "__wab_instance",
              sty.loginTroubleshootingModal
            )}
            onOpenChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, [
                "loginTroubleshootingModal",
                "open"
              ]).apply(null, eventArgs);

              if (
                eventArgs.length > 1 &&
                eventArgs[1] &&
                eventArgs[1]._plasmic_state_init_
              ) {
                return;
              }
            }}
            open={generateStateValueProp($state, [
              "loginTroubleshootingModal",
              "open"
            ])}
          />

          <ContactModal
            data-plasmic-name={"contactModal"}
            data-plasmic-override={overrides.contactModal}
            className={classNames("__wab_instance", sty.contactModal)}
            onOpenChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, ["contactModal", "open"]).apply(
                null,
                eventArgs
              );

              if (
                eventArgs.length > 1 &&
                eventArgs[1] &&
                eventArgs[1]._plasmic_state_init_
              ) {
                return;
              }
            }}
            open={generateStateValueProp($state, ["contactModal", "open"])}
          />
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "desktop",
    "content",
    "mobile",
    "loginTroubleshootingModal",
    "contactModal"
  ],
  desktop: ["desktop", "content"],
  content: ["content"],
  mobile: ["mobile"],
  loginTroubleshootingModal: ["loginTroubleshootingModal"],
  contactModal: ["contactModal"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  desktop: "div";
  content: "div";
  mobile: "div";
  loginTroubleshootingModal: typeof LoginTroubleshootingModal;
  contactModal: typeof ContactModal;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicForgotPassword__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicForgotPassword__VariantsArgs;
    args?: PlasmicForgotPassword__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicForgotPassword__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicForgotPassword__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicForgotPassword__ArgProps,
          internalVariantPropNames: PlasmicForgotPassword__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicForgotPassword__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicForgotPassword";
  } else {
    func.displayName = `PlasmicForgotPassword.${nodeName}`;
  }
  return func;
}

export const PlasmicForgotPassword = Object.assign(
  // Top-level PlasmicForgotPassword renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    desktop: makeNodeComponent("desktop"),
    content: makeNodeComponent("content"),
    mobile: makeNodeComponent("mobile"),
    loginTroubleshootingModal: makeNodeComponent("loginTroubleshootingModal"),
    contactModal: makeNodeComponent("contactModal"),

    // Metadata about props expected for PlasmicForgotPassword
    internalVariantProps: PlasmicForgotPassword__VariantProps,
    internalArgProps: PlasmicForgotPassword__ArgProps,

    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/forgot-password",
      pagePath: "/forgot-password",
      params: {},
      query: {}
    })
  }
);

export default PlasmicForgotPassword;
/* prettier-ignore-end */
